import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deletePartAction } from '../../../redux/actions/partsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const DeletePartModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const part = useSelector((state) => state.parts?.part);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deletePartAction(part.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення деталі'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цю деталь?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeletePartModal;
